import { Button } from "antd";
import landing from 'assets/img/landing.svg';
import styles from './EmailVerificationPage.module.less';
import { useTranslation } from "react-i18next";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { resendVerificationEmail } from "redux/reducers/authenticationSlice";
import { CheckCircleOutlined } from '@ant-design/icons';
import OmniNotification from "components/OmniNotification";
export default function EmailVerificationPage() {
  const { logout, user } = useAuth0();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const {t} = useTranslation();
  const resendVerificationEmailAction = async () => {
    setIsLoading(true);
    const resendResult = await dispatch(resendVerificationEmail());
    //@ts-ignore
    if(resendVerificationEmail.fulfilled.match(resendResult)){
      setIsLoading(false);
      OmniNotification.success({
        message: t('EmailVerificationPage.ResendSuccess')
      });
    }
  }
  return (
    <>
    <div className={styles.emailVerification}>
      <div className={styles.emailVerificationLogo}>
          <img src={landing} alt="logo" />
      </div>
      <div className={styles.emailVerificationWrapper}>
        <div className={styles.emailVerificationEmailIcon}>
          <img src='/envelope-icon.png' alt="mail"/>
        </div>
        <div className={styles.emailVerificationContent}>
          <h1>{t('EmailVerificationPage.Header')}</h1>
          <p>{t('EmailVerificationPage.EmailSentToMessage')}<a href={"emailto:" + user?.email}>{user?.email}</a>.</p>
          <p>{t('EmailVerificationPage.Instruction')}</p>
        </div>
      <Button
            data-testid="submit-btn"
            loading={isLoading}
            type="primary"
            htmlType="submit"
            size="large"
            onClick={() =>
              logout({
                returnTo: window.location.origin,
              })
            }
            >
             {t('EmailVerificationPage.ReturnToLogin')}
            
          </Button>
      </div>
      <div className={styles.emailVerificationResendWrapper}>
        <p>{t('EmailVerificationPage.ResendMessage')}<a onClick={resendVerificationEmailAction}>{t('EmailVerificationPage.ResendLink')}</a>.</p>
      </div>
    </div>
    
    </>
  );
}
